import { css } from 'lit';
export const audioStyles = css`  
  .audio-player {
  background: #111;
  border-radius: 5px;
  padding: 5px;
  color: #fff;
  display: flex;
  align-items: center;
  position: relative;
  margin: 0 0 25px;
  }
  
  .audio-name {
  position: absolute;
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
  width: 100%;
  left: 0;
  z-index: 2;
  text-transform: capitalize;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 400;
  top: calc(100% + 2px);
  background: #111;
  margin: 0;
  border-radius: 3px;
  }
  
  .play-btn {
  width: 30px;
  min-width: 30px;
  height: 30px;
  background: url("https://goodweidao.com/static/blogs/media/audio-player-icon-sprite.png") 0 center/500% 100% no-repeat;
  /* background: url("https://goodweidao.com/static/blogs/media/audio-player-icon-sprite.png") 0 center/500% 100% no-repeat; */
  appearance: none;
  border: none;
  text-indent: -999999px;
  overflow: hidden;
  }
  
  .play-btn.playing {
  background: url("https://goodweidao.com/static/blogs/media/audio-player-icon-sprite.png") 25% center/500% 100% no-repeat;
  }
  
  .volume-bar {
  width: 30px;
  min-width: 30px;
  height: 30px;
  background: url("https://www.goodweidao.com/static/blogs/media/audio-player-icon-sprite.png") 50% center/500% 100% no-repeat;
  position: relative;
  }
  
  .volume-bar.half {
  background: url("https://www.goodweidao.com/static/blogs/media/audio-player-icon-sprite.png") 75% center/500% 100% no-repeat;
  }
  .volume-bar.over {
  background: url("https://www.goodweidao.com/static/blogs/media/audio-player-icon-sprite.png") 100% center/500% 100% no-repeat;
  }
  
  .volume-field {
  display: none;
  position: absolute;
  appearance: none;
  height: 20px;
  right: 100%;
  top: 50%;
  transform: translateY(-50%) rotate(180deg);
  z-index: 5;
  margin: 0;
  border-radius: 2px;
  background: #ffffff;
  }
  
  .volume-field::-webkit-slider-thumb {
  appearance: none;
  height: 20px;
  width: 10px;
  background: #6d78ff;
  }
  
  .volume-field::-moz-range-thumb {
  appearance: none;
  height: 20px;
  width: 10px;
  background: #6d78ff
  }
  
  .volume-field::-ms-thumb  {
  appearance: none;
  height: 20px;
  width: 10px;
  background: #6d78ff
  }
  
  .volume-bar:hover .volume-field {
  display: block;
  }
  
  .progress-indicator {
  display: flex;
  justify-content: flex-end;
  position: relative;
  flex: 1;
  font-size: 12px;
  align-items: center;
  height: 20px;
  }
  
  .progress-bar {
  flex: 1;
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 2;
  transform: translateY(-50%);
  width: 100%;
  appearance: none;
  margin: 0;
  overflow: hidden;
  background: none;
  }
  
  .progress-bar::-webkit-slider-thumb {
  appearance: none;
  height: 20px;
  width: 0;
  box-shadow: -300px 0 0 300px #ffffff38;
  }
  
  .progress-bar::-moz-range-thumb {
  appearance: none;
  height: 20px;
  width: 0;
  box-shadow: -300px 0 0 300px #ffffff21;
  }
  
  .progress-bar::-ms-thumb {
  appearance: none;
  height: 20px;
  width: 0;
  box-shadow: -300px 0 0 300px #ffffff21;
  }
  
  .duration,
  .current-time {
  position: relative;
  z-index: 1;
  text-shadow: 0 0 2px #111;
  }
  
  .duration {
  margin-left: 2px;
  margin-right: 5px;
  }
  
  .duration::before {
  content: '/';
  display: inline-block;
  margin-right: 2px;
  }
  
  canvas {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  opacity: 0.4;
  }
` ;
